// Previous Information Item is the month before the current month
// In DESC mode index + 1 and in ASC mode index - 1
const calculateConsumption = (currentInformationItem, previousInformationItem) => {

    let isPreviousMonthProvided = false,
        consumptionElectricity = 0,
        consumptionElectricityComment = "",
        gainPhotovoltaic = 0,
        gainPhotovoltaicComment = "",
        consumptionWater = 0,
        consumptionWaterComment = "",
        consumptionHeating = 0,
        consumptionHeatingComment = "";

    if (!previousInformationItem ||
        !(((currentInformationItem.year === previousInformationItem.year) &&
            (currentInformationItem.month === previousInformationItem.month + 1))
            || ((currentInformationItem.year === previousInformationItem.year + 1) &&
                (currentInformationItem.month === 1 && previousInformationItem.month === 12))
        )
    ) {
        isPreviousMonthProvided = false;
    } else {
        isPreviousMonthProvided = true;
    }

    if (isPreviousMonthProvided) {

        // calculate data for entries
        if (currentInformationItem.electricity && previousInformationItem.electricity) {
            consumptionElectricity = currentInformationItem.electricity - previousInformationItem.electricity;
            if (consumptionElectricity % 1 !== 0) {
                consumptionElectricity = consumptionElectricity.toFixed(2)
            }
        }
        if (currentInformationItem.photovoltaic && previousInformationItem.photovoltaic) {
            gainPhotovoltaic = currentInformationItem.photovoltaic - previousInformationItem.photovoltaic;
            if (gainPhotovoltaic % 1 !== 0) {
                gainPhotovoltaic = gainPhotovoltaic.toFixed(2)
            }
        }
        if (currentInformationItem.water && previousInformationItem.water) {
            consumptionWater = currentInformationItem.water - previousInformationItem.water;
            if (consumptionWater % 1 !== 0) {
                consumptionWater = consumptionWater.toFixed(2)
            }
        }
        if (currentInformationItem.heating && previousInformationItem.heating) {
            consumptionHeating = currentInformationItem.heating - previousInformationItem.heating;
            if (consumptionHeating % 1 !== 0) {
                consumptionHeating = consumptionHeating.toFixed(2)
            }
        }

        // add comments to data if provided
        if(currentInformationItem.commentElectricity){
            consumptionElectricityComment = currentInformationItem.commentElectricity
        }
        if(currentInformationItem.commentPhotovoltaic){
            gainPhotovoltaicComment = currentInformationItem.commentPhotovoltaic
        }
        if(currentInformationItem.commentWater){
            consumptionWaterComment = currentInformationItem.commentWater
        }
        if(currentInformationItem.commentHeating){
            consumptionHeatingComment = currentInformationItem.commentHeating
        }
    }


    return {
        isPreviousMonthProvided,
        consumptionElectricity,
        consumptionElectricityComment,
        gainPhotovoltaic,
        gainPhotovoltaicComment,
        consumptionWater,
        consumptionWaterComment,
        consumptionHeating,
        consumptionHeatingComment
    }
}

const filterItemsOfYear = (informationItems, year) => {
    var informationItemsToDisplay = Object.values(informationItems[year])
    const previousYear = informationItems[year - 1] ? Object.values(informationItems[year - 1]) : undefined

    // set December of previous year as first value in informationItems
    // --> calculation of consumption in january is possible
    if (previousYear) {
        // december of previous year must exist
        const decemberOfPrevYear = previousYear.find(obj => obj.month === 12)
        if (decemberOfPrevYear) {
            informationItemsToDisplay = [decemberOfPrevYear].concat(informationItemsToDisplay)
        }
    }

    return informationItemsToDisplay;
}

const generateAnnualComparison = (informationItems, firstYearToDisplay, lastYearToDisplay) => {
    var informationItemsToDisplay = []
    var years = Object.keys(informationItems)

    // if first and last year are not set correctly just display all items
    if (!firstYearToDisplay ||
        !lastYearToDisplay ||
        !years.includes(firstYearToDisplay.toString()) ||
        !years.includes(lastYearToDisplay.toString())) {
        firstYearToDisplay = years[0];
        lastYearToDisplay = years[years.length - 1]
    }

    Object.keys(informationItems).forEach((key, index) => {
        if (parseInt(key) < parseInt(firstYearToDisplay) || parseInt(key) > parseInt(lastYearToDisplay)) {
            return;
        }
        const informationItemsPerYear = filterItemsOfYear(informationItems, key)

        var calculatedConsumptions = []

        Object.values(informationItemsPerYear).forEach((item, index) => {
            if (index > 0) {
                const result = calculations.calculateConsumption(informationItemsPerYear[index],
                    informationItemsPerYear[index - 1] ? informationItemsPerYear[index - 1] : null)
                calculatedConsumptions = calculatedConsumptions.concat([result])
            }
        })

        var consumptionElectricity = 0;
        var consumptionElectricityComment = "";
        var consumptionHeating = 0;
        var consumptionHeatingComment = "";
        var gainPhotovoltaic = 0;
        var gainPhotovoltaicComment = "";
        var consumptionWater = 0;
        var consumptionWaterComment = "";

        concealMeterChanges(calculatedConsumptions)

        calculatedConsumptions.forEach((item, index) => {
            consumptionElectricity += parseFloat(item["consumptionElectricity"])
            if(item["electricityMeterChange"]){
                consumptionElectricityComment = "Zählerwechsel in diesem Jahr automatisiert korrigiert"
            }
            consumptionHeating += parseFloat(item["consumptionHeating"])
            if(item["heatingMeterChange"]){
                consumptionHeatingComment = "Zählerwechsel in diesem Jahr automatisiert korrigiert"
            }
            gainPhotovoltaic += parseFloat(item["gainPhotovoltaic"])
            if(item["photovoltaicMeterChange"]){
                gainPhotovoltaicComment = "Zählerwechsel in diesem Jahr automatisiert korrigiert"
            }
            consumptionWater += parseFloat(item["consumptionWater"])
            if(item["waterMeterChange"]){
                consumptionWaterComment = "Zählerwechsel in diesem Jahr automatisiert korrigiert"
            }
        })

        if (consumptionElectricity % 1 !== 0) {
            consumptionElectricity = consumptionElectricity.toFixed(2)
        }
        if (consumptionHeating % 1 !== 0) {
            consumptionHeating = consumptionHeating.toFixed(2)
        }
        if (gainPhotovoltaic % 1 !== 0) {
            gainPhotovoltaic = gainPhotovoltaic.toFixed(2)
        }
        if (consumptionWater % 1 !== 0) {
            consumptionWater = consumptionWater.toFixed(2)
        }
        informationItemsToDisplay = informationItemsToDisplay.concat([
            {
                year: key,
                consumptionElectricity: consumptionElectricity,
                consumptionElectricityComment: consumptionElectricityComment,
                consumptionHeating: consumptionHeating,
                consumptionHeatingComment: consumptionHeatingComment,
                gainPhotovoltaic: gainPhotovoltaic,
                gainPhotovoltaicComment: gainPhotovoltaicComment,
                consumptionWater: consumptionWater,
                consumptionWaterComment: consumptionWaterComment
            }
        ])
    })
    return informationItemsToDisplay;
}

// this function calculates the development of consumption over multiple years for the specified month
const generateMonthlyComparison = (informationItems, monthToDisplay, firstYearToDisplay, lastYearToDisplay) => {
    var informationItemsToDisplay = []
    var years = Object.keys(informationItems)

    // if first and last year are not set correctly just display all items
    if (!firstYearToDisplay ||
        !lastYearToDisplay ||
        !years.includes(firstYearToDisplay.toString()) ||
        !years.includes(lastYearToDisplay.toString())) {
        firstYearToDisplay = years[0];
        lastYearToDisplay = years[years.length - 1]
    }

    Object.keys(informationItems).forEach((key, index) => {
        if (parseInt(key) < parseInt(firstYearToDisplay) || parseInt(key) > parseInt(lastYearToDisplay)) {
            return;
        }

        const informationItemsPerYear = filterItemsOfYear(informationItems, key)

        var previousMonth = undefined
        var currentMonth = undefined

        Object.values(informationItemsPerYear).forEach((item, index) => {
            if(monthToDisplay === 1 && item["month"] === 12 && index === 0){
                previousMonth = item
            }
            if(item["month"] === monthToDisplay - 1){
                previousMonth = item
            }
            if(item["month"] === monthToDisplay){
                currentMonth = item
            }
        })

        if(!previousMonth || !currentMonth){
            return;
        }

        const calculatedConsumption = calculateConsumption(currentMonth, previousMonth)
        
        var consumptionElectricity = parseFloat(calculatedConsumption["consumptionElectricity"]);
        var consumptionElectricityComment = calculatedConsumption["consumptionElectricityComment"];
        var consumptionHeating = parseFloat(calculatedConsumption["consumptionHeating"]);
        var consumptionHeatingComment = calculatedConsumption["consumptionHeatingComment"];
        var gainPhotovoltaic = parseFloat(calculatedConsumption["gainPhotovoltaic"]);
        var gainPhotovoltaicComment = calculatedConsumption["gainPhotovoltaicComment"];
        var consumptionWater = parseFloat(calculatedConsumption["consumptionWater"]);
        var consumptionWaterComment = calculatedConsumption["consumptionWaterComment"];
        
        if (consumptionElectricity % 1 !== 0) {
            consumptionElectricity = consumptionElectricity.toFixed(2)
        }
        if (consumptionHeating % 1 !== 0) {
            consumptionHeating = consumptionHeating.toFixed(2)
        }
        if (gainPhotovoltaic % 1 !== 0) {
            gainPhotovoltaic = gainPhotovoltaic.toFixed(2)
        }
        if (consumptionWater % 1 !== 0) {
            consumptionWater = consumptionWater.toFixed(2)
        }
        
        
        informationItemsToDisplay = informationItemsToDisplay.concat([
            {
                year: key,
                consumptionElectricity: consumptionElectricity,
                consumptionElectricityComment: consumptionElectricityComment,
                consumptionHeating: consumptionHeating,
                consumptionHeatingComment: consumptionHeatingComment,
                gainPhotovoltaic: gainPhotovoltaic,
                gainPhotovoltaicComment: gainPhotovoltaicComment,
                consumptionWater: consumptionWater,
                consumptionWaterComment: consumptionWaterComment
            }
        ])
    })
    return informationItemsToDisplay;
}

// if the consumption or gain is negative --> the corresponding meter has been changed
// the value is corrected to the average of the previous month and the following month
// if these months are not available, the value of the previous / following month is copied
const concealMeterChanges = (informationItems) => {

    informationItems.forEach(function (item, index) {
        if (Math.abs(parseFloat(item.consumptionElectricity)) > 10000) {
            if (this[index - 1] && this[index + 1]) {
                this[index].consumptionElectricity = (parseFloat(this[index - 1].consumptionElectricity) + parseFloat(this[index + 1].consumptionElectricity)) / 2
                this[index].electricityMeterChange = true
            }
        }
        if (Math.abs(parseFloat(item.consumptionHeating)) > 10000) {
            if (this[index - 1] && this[index + 1]) {
                this[index].consumptionHeating = (parseFloat(this[index - 1].consumptionHeating) + parseFloat(this[index + 1].consumptionHeating)) / 2
                this[index].heatingMeterChange = true
            }
        }
        if (Math.abs(parseFloat(item.gainPhotovoltaic)) > 10000) {
            if (this[index - 1] && this[index + 1]) {
                this[index].gainPhotovoltaic = (parseFloat(this[index - 1].gainPhotovoltaic) + parseFloat(this[index + 1].gainPhotovoltaic)) / 2
                this[index].photovoltaicMeterChange = true
            }
        }
        if (Math.abs(parseFloat(item.consumptionWater)) > 100) {
            if (this[index - 1] && this[index + 1]) {
                this[index].consumptionWater = (parseFloat(this[index - 1].consumptionWater) + parseFloat(this[index + 1].consumptionWater)) / 2
                this[index].waterMeterChange = true
            }
        }
    }, informationItems)
}

const calculations = {
    calculateConsumption,
    filterItemsOfYear,
    generateAnnualComparison,
    generateMonthlyComparison,
    concealMeterChanges
}

export default calculations